import { Button } from './button';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

export function PaginationControls({ 
  page, 
  pages, 
  total, 
  onPageChange,
  showInfo = true 
}) {
  if (pages <= 1) return null;
  
  return (
    <div className="flex items-center justify-between mt-4 pt-4 border-t">
      {showInfo && (
        <span className="text-sm text-muted-foreground">
          Pagina {page} di {pages} ({total} elementi)
        </span>
      )}
      <div className={`flex gap-1 ${!showInfo ? 'w-full justify-center' : ''}`}>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(1)}
          disabled={page === 1}
        >
          <ChevronsLeft className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="flex items-center px-3 text-sm">
          {page} / {pages}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page === pages}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(pages)}
          disabled={page === pages}
        >
          <ChevronsRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
